module.exports = __webpack_public_path__ + "static/media/img015.30e53876.jpg";